/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ControlZeroDayAlertClientSortField = {
    ClientId: 'client_id',
    ResolutionStatus: 'resolution_status',
    ExposureUsd: 'exposure_usd',
    Created: 'created',
    Assignee: 'assignee',
    EscalationStatus: 'escalation_status'
} as const;
export type ControlZeroDayAlertClientSortField = typeof ControlZeroDayAlertClientSortField[keyof typeof ControlZeroDayAlertClientSortField];


export function ControlZeroDayAlertClientSortFieldFromJSON(json: any): ControlZeroDayAlertClientSortField {
    return ControlZeroDayAlertClientSortFieldFromJSONTyped(json, false);
}

export function ControlZeroDayAlertClientSortFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlZeroDayAlertClientSortField {
    return json as ControlZeroDayAlertClientSortField;
}

export function ControlZeroDayAlertClientSortFieldToJSON(value?: ControlZeroDayAlertClientSortField | null): any {
    return value as any;
}

